import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as api from "@/lib/api";
import { UserManagementPanel, ALL_ROLE_OPTIONS } from "@/components/user-management-panel";

const assignableRoles = ALL_ROLE_OPTIONS.filter((r) => r.value !== "super_admin");

export default function OrgUsersPage() {
  const { id } = useParams<{ id: string }>();
  const [orgName, setOrgName] = useState("");

  useEffect(() => {
    if (id) {
      api.getOrganization(id).then((r) => setOrgName(r.organization.name)).catch(() => {});
    }
  }, [id]);

  if (!id) return null;

  return (
    <div data-page="org-users">
    <UserManagementPanel
      title={orgName ? `${orgName} -- Users` : "Organization Users"}
      subtitle="Users with roles in this organization, its schools, and sponsors"
      scopeType="organization"
      scopeId={id}
      fetchUsers={() => api.getOrgUsers(id)}
      assignableRoles={assignableRoles}
      canManage={true}
      showDetailLink
    />
    </div>
  );
}
